import { Article } from "@ecologi/shared";
import { ArticlesHero } from "../ArticlesHero";
import { ArticlesList } from "./ArticlesList";

enum ArticlesListMode {
  Blog = "Blog",
  Projects = "Projects",
}

const ArticlesListModeConfigMap = {
  [ArticlesListMode.Blog]: {
    titleText: "The Ecologi blog",
    subtitleText: "Read about environmental and climate related subjects",
  },
  [ArticlesListMode.Projects]: {
    titleText: "Projects we support",
    subtitleText:
      "Read about the reforestation, habitat restoration, carbon avoidance and removal projects we support",
  },
};

type ArticlesIndexProps = {
  categoryName?: string;
  data: any;
  mode: ArticlesListMode;
};

export const ArticlesIndex = ({
  categoryName,
  data,
  mode,
}: ArticlesIndexProps) => {
  const articles = Object.values(data) as Article[];
  const { titleText, subtitleText } = ArticlesListModeConfigMap[mode];

  return (
    <>
      <ArticlesHero
        data={data}
        isStandalone
        title={titleText + (categoryName ? `: ${categoryName}` : "")}
        subtitleText={subtitleText}
      />
      <ArticlesList articles={articles} />
    </>
  );
};

ArticlesIndex.modes = ArticlesListMode;
